/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateClientSecretRequest } from '../../models/create-client-secret-request';
import { CreateClientSecretResponse } from '../../models/create-client-secret-response';

export interface CreateClientSecret$Params {
  organizationId: string;
  
    /**
     * Client secret name to be created.
     */
    body: CreateClientSecretRequest
}

export function createClientSecret(http: HttpClient, rootUrl: string, params: CreateClientSecret$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateClientSecretResponse>> {
  const rb = new RequestBuilder(rootUrl, createClientSecret.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateClientSecretResponse>;
    })
  );
}

createClientSecret.PATH = '/v1/organizations/{organizationId}/clientsecrets';
